/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

form-modal.js - subclasses the Modal class to add form functionality


*/

class FormModal extends Modal {
  interactiveElements() {
    return this.data.form;
  }

  closeModal(closers) {
    const form = document.querySelector(`#${this.data.id} form`);
    form.setAttribute('aria-hidden', true);

    super.closeModal(closers);
  }

  makeVisible() {
    super.makeVisible();
    const form = document
      .querySelector(`#${this.data.id}`)
      .querySelector('form');
    let modal = this.getModalDOMElement();
    form.style.display = 'inline-block';
    form.setAttribute('aria-hidden', false);

    form.addEventListener('submit', (event) => {
      this.handleModalEvent(event, modal);
    });

    if (form.id === 'rename-form' || form.id === 'subcategory-form') {
      form.querySelectorAll('input.add-form[type=text]')[0].focus();
    }
  }

  makeInvisible() {
    super.makeInvisible();
    const form = document
      .querySelector(`#${this.data.id}`)
      .querySelector('form');
    form.style.display = 'none';
    form.setAttribute('aria-hidden', true);
  }
}
